export enum FromICPStringError {
  FRACTIONAL_MORE_THAN_8_DECIMALS,
  INVALID_FORMAT,
}
